import { type JSX } from 'react';
import { SizePills } from '@/components/ui';
import styles from './SizeSelectionSheet.module.css';
import type { SizeSelectionSheetProps } from './SizeSelectionSheet.types';

export const SizeSelectionSheet = ({
  availableSizes,
  selectedSize,
  paymentStatus,
  onSizeSelect,
  onClose,
  onContinue,
}: SizeSelectionSheetProps): JSX.Element => {
  const isProcessing =
    paymentStatus === 'creating_order' ||
    paymentStatus === 'confirming_payment';

  return (
    <>
      <div className={styles.modalBackdrop} onClick={onClose} />
      <div className={styles.bottomSheetPanel}>
        <div className={styles.sheetHeader}>
          <span className={styles.sheetTitle}>Select Size</span>
          <button className={styles.sheetCloseBtn} onClick={onClose}>
            ✕
          </button>
        </div>
        <div className={styles.sheetContent}>
          <SizePills
            availableSizes={availableSizes}
            selectedSize={selectedSize}
            onSizeSelect={onSizeSelect}
          />
          <button
            className={styles.continueBtn}
            disabled={!selectedSize || isProcessing}
            onClick={onContinue}
          >
            {isProcessing ? (
              <span>Processing...</span>
            ) : (
              <span>Continue to Checkout</span>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default SizeSelectionSheet;
